export enum UserRolesEnum {
  // Basisrollen
  ROLE_USER = 'ROLE_USER',
  ROLE_EDITOR_BASE = 'ROLE_EDITOR_BASE',

  // Rollen für Leseberechtigungen
  ROLE_VIEWER_ORDERREQUESTS = 'ROLE_VIEWER_ORDERREQUESTS',
  ROLE_VIEWER_INSTALLERPASSES = 'ROLE_VIEWER_INSTALLERPASSES',
  ROLE_VIEWER_GRIDREGISTRATIONS = 'ROLE_VIEWER_GRIDREGISTRATIONS',
  ROLE_VIEWER_COMMISSIONING = 'ROLE_VIEWER_COMMISSIONING',
  ROLE_VIEWER_FEEDERCONTRACTS = 'ROLE_VIEWER_FEEDERCONTRACTS',
  ROLE_VIEWER_CONNECTION_CHANGE_REQUESTS = 'ROLE_VIEWER_CONNECTION_CHANGE_REQUESTS',

  // Rollen für Sachbearbeiter
  ROLE_EDITOR = 'ROLE_EDITOR',
  ROLE_EDITOR_CSS = 'ROLE_EDITOR_CSS',
  ROLE_EDITOR_INSTALLERPASSES = 'ROLE_EDITOR_INSTALLERPASSES',
  ROLE_EDITOR_GRIDREGISTRATIONS = 'ROLE_EDITOR_GRIDREGISTRATIONS',
  ROLE_EDITOR_COMMISSIONING = 'ROLE_EDITOR_COMMISSIONING',
  ROLE_EDITOR_FEEDERCONTRACTS = 'ROLE_EDITOR_FEEDERCONTRACTS',
  ROLE_EDITOR_CONNECTION_CHANGE_REQUESTS = 'ROLE_EDITOR_CONNECTION_CHANGE_REQUESTS',

  // Rollen für Key-User
  ROLE_KEYUSER_ORDERREQUESTS = 'ROLE_KEYUSER_ORDERREQUESTS',
  ROLE_KEYUSER_INSTALLERPASSES = 'ROLE_KEYUSER_INSTALLERPASSES',
  ROLE_KEYUSER_GRIDREGISTRATION = 'ROLE_KEYUSER_GRIDREGISTRATION',
  ROLE_KEYUSER_COMMISSIONING = 'ROLE_KEYUSER_COMMISSIONING',
  ROLE_KEYUSER_FEEDERCONTRACTS = 'ROLE_KEYUSER_FEEDERCONTRACTS',
  ROLE_KEYUSER_GRID_SIMULATIONS = 'ROLE_KEYUSER_GRID_SIMULATIONS',
  ROLE_KEYUSER_CONNECTION_CHANGE_REQUESTS = 'ROLE_KEYUSER_CONNECTION_CHANGE_REQUESTS',

  // Rollen für Installateure
  ROLE_INSTALLATEUR = 'ROLE_INSTALLATEUR',
  ROLE_ADMIN_INSTALLATEUR = 'ROLE_ADMIN_INSTALLATEUR',

  // Rollen für Admins
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_SUPERADMIN = 'ROLE_SUPERADMIN',
  ROLE_USER_ADMIN = 'ROLE_USER_ADMIN',
  // Andere Rollen
  ALL_USERS = 'ALL_USERS',
  ROLE_PENDING_CONFIRM = 'ROLE_PENDING_CONFIRM',
  ROLE_PENDING_VERIFY = 'ROLE_PENDING_VERIFY'
}

export type UserRole = `${UserRolesEnum}` | UserRolesEnum;
